import { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "../api/api";
import { clearStoredAuth, getStoredUser, setStoredAuth } from "./storage";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => getStoredUser());
  const [checking, setChecking] = useState(true);

  const refreshMe = async () => {
    const res = await api.get("/auth/me");
    const u = res?.data?.user || null;
    setUser(u);
    if (u) setStoredAuth({ user: u });
    else clearStoredAuth();
    return u;
  };

const logout = async () => {
  try {
    await api.post("/auth/logout");
  } catch {}

  // 🔥 HAPUS TOKEN
  localStorage.removeItem("token");

  setUser(null);
  clearStoredAuth();
};

  const login = async ({ username, password }) => {
    const res = await api.post("/auth/login", { username, password });

    // 🔥 SIMPAN TOKEN (INI YANG PENTING BANGET)
    if (res?.data?.token) {
      localStorage.setItem("token", res.data.token);
    }

    const nextUser = res?.data?.user || null;

    if (!nextUser) throw new Error("Login gagal");

    setUser(nextUser);
    setStoredAuth({ user: nextUser });

    return nextUser;
  };

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setChecking(true);
        const token = localStorage.getItem("token");
        if (!token) {
          if (!cancelled) {
            setUser(null);
            clearStoredAuth();
          }
          return;
        }

        await refreshMe();
      } catch {
        if (!cancelled) {
          setUser(null);
          clearStoredAuth();
        }
      } finally {
        if (!cancelled) setChecking(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  const value = useMemo(() => {
    const role = user?.role;
    return {
      user,
      role,
      isAdmin: role === "admin",
      isAuthenticated: Boolean(user),
      checking,
      login,
      logout,
      refreshMe,
    };
  }, [user, checking]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
